import PropTypes from 'prop-types'
import { useState } from 'react'

import { FormModal, Snackbar } from '../../default'
import { CreatePlanForm } from '../../forms'

/**
 * @description Renders a modal for updating a plan.
 *
 * @author Maria Eduarda Franke
 * @param {boolean} open - Determines whether the modal is open or not.
 * @param {function} onClose - Callback function to close the modal.
 * @param {object} selectedPlan - The selected plan object to be updated.
 * @returns {JSX.Element} - The rendered UpdatePlanModal component.
 */
const UpdatePlanModal = ({ open, onClose, selectedPlan }) => {

    const [showSnackbar, setShowSnackbar] = useState(false)

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') return
        setShowSnackbar(false)
    }

    return (
        <>
            <FormModal
                title='Editar Plano'
                id={selectedPlan?.plan_id}
                open={open} onClose={onClose}
            >
                <CreatePlanForm onClose={onClose} setShowSnackbar={setShowSnackbar} selectedPlan={selectedPlan} />
            </FormModal>
            <Snackbar
                open={showSnackbar}
                onClose={handleSnackbarClose}
                vertical='bottom'
                horizontal='right'
                severity='success'
                variant='filled'
                message={`Plano #${selectedPlan?.plan_id} alterado com sucesso!`}
                sx={{ mt: 1 }}
            />
        </>
    )

}

UpdatePlanModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedPlan: PropTypes.object
}

export default UpdatePlanModal